import MicroModal from "micromodal";

const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

const hasVerticalScrollbar = () => {
    return document.documentElement.scrollHeight > document.documentElement.clientHeight;
};

const applyOffset = (offset) => {
    const header = document.querySelector('.header');
    const mobileMenu = document.querySelector("#mobile-menu");
    const backToTop = document.querySelector("#back-to-top");
    const cart = document.querySelector(".cart");
    const cookies = document.querySelector(".cookies-consent");

    if (hasVerticalScrollbar()) {
        document.body.style.paddingRight = `${offset}px`;
        if (cookies) {
            const originalTransition = cookies.style.transition;

            cookies.style.transition = 'none';

            void cookies.offsetHeight;
            
            cookies.style.paddingRight = `${offset}px`;

            requestAnimationFrame(() => {
                cookies.style.transition = originalTransition;
            });
        }
        
        if (cart) {
            cart.style.marginRight = `${offset}px`;
        }
        if (header) {
            header.style.paddingRight = `${offset}px`;
        }
        if (mobileMenu.classList.contains("mobile-menu-one") || mobileMenu.classList.contains("mobile-menu-two")) {
            mobileMenu.style.paddingRight = `${offset}px`;
        }
        if (backToTop && offset > 0) {
            backToTop.style.display = "none";
        } else if(backToTop) {
            backToTop.style.display = "";
        }
    } else {
        document.body.style.paddingRight = '';
        if (cookies) {
            cookies.style.paddingRight = ``;
        }
        if (cart) {
            cart.style.marginRight = ``;
        }
        if (header) {
            header.style.paddingRight = '';
        }
        if (mobileMenu.classList.contains("mobile-menu-one") || mobileMenu.classList.contains("mobile-menu-two")) {
            mobileMenu.style.paddingRight = '';
        }
    }
};

function modalShow() {
    document.body.style.overflow = 'hidden';
    applyOffset(scrollbarWidth);
}

function modalClose(modal) {
    applyOffset(0);
    const mobileMenu = document.querySelector("#mobile-menu");
    let value = mobileMenu.classList.contains("active");
    if (mobileMenu.classList.contains("mobile-menu-one") || mobileMenu.classList.contains("mobile-menu-two")) {
        value = false;
    }
    if (value == true) {
        document.body.style.overflow = 'hidden';
    } else {
        document.body.style.overflow = '';
    }

    if (modal.classList.contains("modal-service") || modal.classList.contains("modal-reviews")) {
        const modalContent = modal.querySelector(".modal__overlay");
        if (modalContent) {
            modalContent.innerHTML = "";
        }
    }
}

export const modalConfig = {
    onShow: modalShow,
    onClose: modalClose,
    awaitOpenAnimation: true,
    awaitCloseAnimation: true,
    disableFocus: true,
    disableScroll: true,
};

export const showModal = (modalID) => MicroModal.show(modalID, modalConfig);